import { getTintVTOService } from "services/tintvto"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { RootState } from "../store"
import { selectUser } from "./userSlice"

export const initializeUser = createAsyncThunk<void, void, { state: RootState }>(
  "user/initializeUser",
  async (_, { getState }) => {
    const state = getState()
    const user = selectUser(state)
    if (user && user.userInfo.username) {
      const service = getTintVTOService()
      if (user?.token && user?.token?.awsAccessKey) service.changeAwsToken(user.token)

      service.changeUserType(user.userInfo.integrationType)
    }
  }
)
